export const PRODUCT_INTERACTION_TYPES = {
  SIMILAR_ITEMS: 'ProductSimilarItems',
  SIMILAR_ITEMS_SASH: 'ProductSimilarItemsSash',
  SELLER_ITEMS: 'ProductSellerItems',
  SELLER_SEE_MORE: 'ProductSellerSeeMore',
  PRODUCT_LIKE: 'ProductLike',
  PRODUCT_UNLIKE: 'ProductUnlike',
  PRODUCT_SAVE: 'ProductSave',
  PRODUCT_UNSAVE: 'ProductUnsave',
  BASED_ON_RECENT_VIEWS_PDP: 'BasedOnRecentViewsPDP',
  BASED_ON_RECENT_VIEWS_HOME: 'BasedOnRecentViewsHome',
};

export const PRODUCT_YOU_MIGHT_BE_INTO_LOCAL_STORAGE_KEY =
  'searchTermSuggestions';

export const IS_PLA_REFERER = 'isPLAReferer';

// Shipping time nudge experiment (WEB-8333)
// Transit day ranges per country — sourced from depop/shipping conf/shipping.conf
export const TRANSIT_DAYS_BY_COUNTRY: Record<
  string,
  { min: number; max: number }
> = {
  GB: { min: 4, max: 6 },
  US: { min: 5, max: 8 },
  AU: { min: 4, max: 7 },
};

export const DEFAULT_TRANSIT_DAYS = { min: 6, max: 9 };

export const VARIANT_SHIPPING_DAYS_LIMIT = 3;
